import * as React from 'react';
import { Input as HenInput } from '@highereducation/hen-ui';
import { subInputName } from '../submit';
import {
  FieldLegend,
  FieldErrorMessage,
  type FieldComponentProps,
} from './parts';

/**
 * NAME field — composite of visible sub-inputs (first/last, GF sub-ids `.3`/`.6`).
 * Each sub-input name is `input_{formId}_{inputId}`; the submit builder maps them
 * to `nameValues: { first, last, ... }`.
 */
export function NameField({ field, formId, error }: FieldComponentProps) {
  const inputs = (field.inputs ?? []).filter((input) => !input.isHidden);

  return (
    <>
      <fieldset className='flex flex-col gap-xxs border-0 p-0'>
        <FieldLegend field={field} />
        <div className='flex flex-col gap-sm sm:flex-row'>
          {inputs.map((input) => {
            const name = subInputName(formId, input.id);
            const label = input.customLabel || input.label;
            return (
              <div className='flex w-full flex-col' key={input.id}>
                {label && (
                  <label
                    htmlFor={name}
                    className='mb-xxs block text-b5 text-body'
                  >
                    {label}
                  </label>
                )}
                <HenInput
                  id={name}
                  name={name}
                  type='text'
                  placeholder={input.placeholder}
                  required={Boolean(field.isRequired)}
                />
              </div>
            );
          })}
        </div>
      </fieldset>
      <FieldErrorMessage error={error} />
    </>
  );
}
